import Layout from '../components/Layout';
import { GestionTiposNovedadComponent } from '../components/GestionTiposNovedad';

const GestionNovedades = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {/* Encabezado */}
          <div className="bg-white shadow-sm rounded-lg px-4 py-5 sm:p-6">
            <div className="md:flex md:items-center md:justify-between">
              <div className="min-w-0 flex-1">
                <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                  Gestión de Novedades
                </h2>
                <p className="mt-1 text-sm text-gray-500">
                  Administra los tipos de novedad y sus configuraciones
                </p>
              </div>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="bg-white shadow-sm rounded-lg">
            <div className="p-4 sm:p-6 lg:p-8">
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div className="col-span-1">
                  <GestionTiposNovedadComponent />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default GestionNovedades;
